<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";
    import {nextTick} from "vue";

    export default {
        mixins: [
            TileQuestion,
        ],
        props: {
            title: {
                default(){
                    return 'Frame Combination';
                }
            },
            component_id: {
                default(){
                    return 'frame_style';
                }
            },
            checkedPanels: {
                required: true,
            },
            typeRange: {
                required: false,
                default() {
                    return 0;
                }
            }
        },
        computed:{
            valid_selection(){
                if (!this.options_loaded) {
                    return false;
                }

                return this.filtered_option_list.find(y => {
                            return y.value == this.localTarget;
                        }) !== undefined;
            },
            thumbURL(){
                return '/thumb/frame-combination/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/frame-combination?type_range=' + this.typeRange;
            },
            cache_key(){
                return '_' + this.typeRange;
            },
            filtered_option_list(){
                if (this.option_list === null) {
                    return [];
                }

                return this.option_list.filter((key) => {
                    var panelLeft = '!==';
                    var panelRight = '!==';
                    var panelTop = '!==';

                    if (this.checkedPanels.indexOf("left") !== -1) {
                        panelLeft = '===';
                    }
                    if (this.checkedPanels.indexOf("right") !== -1) {
                        panelRight = '===';
                    }
                    if (this.checkedPanels.indexOf("top") !== -1) {
                        panelTop = '===';
                    }

                    return eval("key.value !== null && key.left " + panelLeft + " true && key.right " + panelRight + " true && key.top " + panelTop + " true");
                });
            }
        },
        methods: {
            select_first(){
                nextTick(() => {
                    if (!Array.isArray(this.filtered_option_list)) {
                        this.localTarget = undefined;
                        return;
                    }

                    if ((this.filtered_option_list.length === 0)) {
                        this.localTarget = undefined;
                        return;
                    }

                    var new_value = this.filtered_option_list[0];

                    this.localTarget = new_value.value;
                });
            },
        },
    }
</script>
